<template>
<div>
   <!-- Works -->
   <section class="flex flex-col w-full h-full antialiased bg-black  ">
      <Header></Header>
      <slider class="xl:-mt-20" cat='4'></slider>
    </section>
    <div >
      <section class="py-10 bg-black">
        <works :name="pageTitle" cat='4' ></works>
      </section>
      </div>
    <light-box></light-box>
  <contact-us></contact-us>
</div>

</template>

<script>
import Header from '@/components/header.vue'
import Slider from '@/components/slider.vue'

import Works from '@/components/works.vue'

import ContactUs from '@/components/contactUs.vue'

import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMeta } from 'vue-meta'

export default defineComponent({
  name: 'Branding',
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    workCat: {
      type: Number
    }

  },
  setup () {
    const { t } = useI18n({})
    const title = t('general.branding.title')
    const desc = t('general.branding.description')
    const keys = t('general.branding.keys')

   useMeta({
      title: `${title}`,
      description: `${desc}`,
      meta: [
        {
          name: 'keywords',
          content: `${keys}`
        },
        { property: 'og:title', content: `${title}` },
        { property: 'og:keywords', content: `${keys}` },

        { property: 'og:site_name', content: 'Jump sa' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' },

        { property: 'og:url', content: 'https://jump.sa' },
        { property: 'og:description', content: `${desc}` },

        // Twitter card
        { name: 'twitter:card', content: `${desc}` },
        { name: 'twitter:site', content: 'https://jump.sa' },
        { name: 'twitter:title', content: `${title}` },
        { name: 'twitter:description', content: `${desc}` },
        // Your twitter handle, if you have one.
        { name: 'twitter:creator', content: '@Jump sa' },

        // Google / Schema.org markup:
        { itemprop: 'name', content: `${title}` },
        { itemprop: 'description', content: `${desc}` }
      ]

    })
  },
  components: {
    ContactUs,
    Works,
    Header,
    Slider
  }

})
</script>
